export enum PaperPackingType {
    HotCup = 1,
    HotLid = 2,
    ColdCup = 3,
    ColdFlatLid = 4,
    ColdDomedLid = 5,
    Sleeve = 6,
    Straw = 7,
    NitroLid = 8
  }